import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["word", "toggleText", "toggleAllText", "wordCard"]

  connect() {
    this.wordsHidden = false
  }

  toggleWord(event) {
    const index = event.currentTarget.dataset.index
    const wordTarget = this.wordTargets.find(target => target.dataset.index === index)
    const toggleTextTarget = this.toggleTextTargets.find(target => target.dataset.index === index)
    
    if (wordTarget.classList.contains("blur-text")) {
      wordTarget.classList.remove("blur-text")
      toggleTextTarget.textContent = "Hide Word"
    } else {
      wordTarget.classList.add("blur-text")
      toggleTextTarget.textContent = "Reveal Word"
    }
  }

  toggleAllWords() {
    this.wordsHidden = !this.wordsHidden
    
    this.wordTargets.forEach((wordTarget, index) => {
      const toggleTextTarget = this.toggleTextTargets.find(target => target.dataset.index === index.toString())
      
      if (this.wordsHidden) {
        wordTarget.classList.add("blur-text")
        toggleTextTarget.textContent = "Reveal Word"
      } else {
        wordTarget.classList.remove("blur-text")
        toggleTextTarget.textContent = "Hide Word"
      }
    })
    
    this.toggleAllTextTarget.textContent = this.wordsHidden ? "Reveal All Words" : "Hide All Words"
  }

  playWord(event) {
    const word = event.currentTarget.dataset.word
    
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(word)
      utterance.rate = 0.8 // Slightly slower rate for clarity
      speechSynthesis.speak(utterance)
    } else {
      alert("Sorry, your browser doesn't support text-to-speech!")
    }
  }
} 